export interface BudgetUsage {
    spent: number;
    remaining: number;
    percentUsed: number;
}

export const calculateBudgetUsage = (budgetAmount: number, actualSpent: number): BudgetUsage => {
    const spent = Math.max(0, actualSpent);
    const remaining = budgetAmount - spent;
    const percentUsed = budgetAmount > 0 ? (spent / budgetAmount) * 100 : 0;

    return { spent, remaining, percentUsed };
};
